import { FC, ComponentPropsWithoutRef, PropsWithChildren } from 'react';

import { useSelector } from 'src/modules/useSelector';

const Form: FC<ComponentPropsWithoutRef<'form'> & PropsWithChildren> = ({ children, ...props }) => {
    // TODO: fix ts-check
    // origin
    // const xsrfToken = useSelector(({ request }) => request.xsrfToken);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
    const xsrfToken = useSelector(({ request }) => (request as any).xsrfToken) as string;

    return (
        <form {...props}>
            <input type="hidden" name="_xsrf" value={xsrfToken} />
            {children}
        </form>
    );
};

export default Form;
